import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Pages.css";

const WhySeagull = () => {
  const differentiators = [
    {
      title: "U.S.-Market Alignment",
      description: "Programs are designed for U.S. buyers, compliance context, and competitive realities.",
    },
    {
      title: "Revenue-First Execution",
      description: "We prioritize lead quality, conversion rate, and pipeline velocity over vanity metrics.",
    },
    {
      title: "Flexible Engagement Model",
      description: "From focused projects to ongoing growth operations support, we scale with your team.",
    },
    {
      title: "Cross-Functional Expertise",
      description: "Our specialists bridge data, campaigns, operations, and analytics to reduce handoff gaps.",
    },
  ];

  const outcomes = [
    "Better ICP coverage and targeting precision",
    "More qualified meetings from the same budget",
    "Stronger handoff between marketing and sales",
    "Clear reporting tied to revenue performance",
  ];

  return (
    <main>
      <Helmet>
        <title>Why Choose ThinkRise USA | Trusted B2B Experts</title>
        <meta
          name="description"
          content="Discover why teams choose ThinkRise USA for U.S.-market expertise, revenue-first execution, and scalable growth programs built for measurable outcomes."
        />
      </Helmet>
      <section className="page-hero why-hero">
        <div className="container">
          <h1 className="page-hero-title">Why ThinkRise USA</h1>
          <p className="page-hero-subtitle">
            We are a strategic growth partner focused on measurable outcomes, not generic activity.
          </p>
          <Link to="/contact" className="btn">Book a Strategy Call</Link>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Our Differentiators</h2>
          <div className="why-differentiators-grid">
            {differentiators.map((item, index) => (
              <article key={item.title} className="why-differentiator-card">
                <div className="why-chip">{index + 1}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section why-outcomes-section">
        <div className="container">
          <h2 className="section-title">What Clients Can Expect</h2>
          <div className="why-outcomes-grid">
            {outcomes.map((item) => (
              <div key={item} className="why-outcome-item">{item}</div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default WhySeagull;
